import { Action, createAction } from 'redux-act';

import Contact from '../../../models/interfaces/Contact';
import TimestampPayload from '../TimestampPayload';

export interface SaveContactPayload extends TimestampPayload {
  contact: Contact;
}
export const saveContact = createAction<SaveContactPayload>('SAVE_CONTACT');
export type SaveContactActionType = Action<SaveContactPayload>;

export interface ContactSavedPayload extends TimestampPayload {
  contact: Contact;
}
export const contactSaved = createAction<ContactSavedPayload>('CONTACT_SAVED');

export interface ContactSaveFailedPayload extends TimestampPayload {
  placeUuid: string;
  contactUuid: string;
}
export const contactSaveFailed = createAction<ContactSaveFailedPayload>('CONTACT_SAVE_FAILED');
